import type { JSX } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCandidate } from '../hooks/useCandidate';
import { CandidateDetailHeader } from '../components/CandidateDetailHeader';
import { CandidateExperiencesSection } from '../components/CandidateExperiencesSection';
import { CandidateEducationsSection } from '@/features/educations/components/CandidateEducationsSection';

export function CandidateDetailPage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { candidate, isLoading, isError } = useCandidate(id);

  const handleBack = (): void => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="container py-6">
        <div className="text-center py-8 text-muted-foreground">Loading candidate...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container py-6">
        <div className="text-center py-8 text-destructive">Error loading candidate</div>
      </div>
    );
  }

  if (!candidate) {
    return (
      <div className="container py-6">
        <div className="text-center py-8 text-muted-foreground">Candidate not found</div>
      </div>
    );
  }

  return (
    <div className="container py-6 space-y-6">
      <CandidateDetailHeader candidate={candidate} onBack={handleBack} />
      <CandidateExperiencesSection candidateId={id!} />
      <CandidateEducationsSection candidateId={id!} />
    </div>
  );
}
